import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { createSearchParams, Link } from 'react-router'
import { usePortalTranslate } from '@/hooks'
import { ProductProcess } from '@/domain/products'
import { useAppSelector } from '@/redux/hooks'

interface ProductProcessesTableProps {
  processes: ProductProcess[]
}

export const ProductProcessesTable: React.FC<ProductProcessesTableProps> = ({
  processes
}) => {
  const { t } = useTranslation()
  const { trans } = usePortalTranslate({})

  const ecommerceId = useAppSelector((s) => s.generalData.selectedEcommerce)

  return (
    <div className="mt-4 grid w-full grid-cols-[repeat(2,_minmax(0,_1fr))] items-center gap-y-2 rounded-lg bg-white">
      {processes.map((process, i) => {
        return (
          <Fragment key={i}>
            <div className="mb-2 h-full border-b border-solid border-grey-2">
              <p>
                <Link
                  to={{
                    pathname: `/returns/orders/${process.id}`,
                    search: createSearchParams({
                      ecommerce_id: ecommerceId ?? ''
                    }).toString()
                  }}
                  className="overflow-hidden text-ellipsis underline"
                >
                  {process.orderNumber}
                </Link>
              </p>
              <span className="overflow-hidden text-ellipsis text-sm">
                {process.returnDate}
              </span>
              <span className="overflow-hidden text-ellipsis text-sm text-grey-2">
                {' - '}
                {t('titles_li.quantity')}: {process.quantity}
              </span>
            </div>
            <div className="mb-2 flex h-full flex-col justify-center border-b border-solid border-grey-2">
              <p className="text-sm">{process.variantName}</p>
              <p className="overflow-hidden text-ellipsis  text-sm">
                {trans(`select_reason_${process.returnReason}`)}
              </p>
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}
